import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

@Component({
	selector: 'app-modal-select-address',
	templateUrl: './modal-select-address.component.html',
	styleUrls: ['./modal-select-address.component.scss']
})
export class ModalSelectAddressComponent extends UIModalBaseComponent implements AfterViewInit {
	@Output() close = new EventEmitter<any | null>();

	options: any = {};
	loading = false;
	search = '';

	addressGroups = [];
	expanded = {};
	selected = null;
	viewMode: 'grid' | 'list' = 'grid';

	allFilteredAddresses = [];

	typesList = [];
	typeFilter = [];

	modalTitle = 'Use Address';

	constructor(
		public app: AppService
	) {
		super();
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	open(mdata: any) {
		this.options = { ...(mdata || {}) };
		this.modalTitle = this.options.modalTitle || 'Use Address';
		this.loading = true;
		this.search = '';
		this.addressGroups = (this.options.addressGroups || []) as any[];
		this.expanded = {};
		this.selected = null;
		this.allFilteredAddresses = [];
		this.viewMode = 'grid';
		this.typesList = [];

		this.addressGroups.forEach((g, i) => {
			const groupType = (g?.type ?? i).toString();
			const label = this.formatGroupLabel(g?.label ?? groupType);
			this.typesList.push({
				id: groupType,
				name: label
			});

			this.expanded[groupType] = true;

			const hit = (g.items || []).find(a => {
				if (this.options.preselectAddress) {
					return this.app.compareAddress(this.options.preselectAddress, a);
				}
				return false;
			});
			if (hit && !this.selected) this.selected = hit;
		});

		this.typeFilter = Array.isArray(this.options?.typeFilter) ? [...this.options.typeFilter] : [];

		this.computeAddressesForList();
		this.loading = false;
		this.modal.open();
	}

	computeAddressesForList() {
		const out = [];
		for (const g of this.addressGroups || []) {
			const groupType = (g?.type ?? '').toString();
			if (this.typeFilter.length && !this.typeFilter.includes(groupType)) continue;
			const badge = {
				label: this.formatGroupLabel(g?.label),
				icon: g?.icon || 'wq wq-location',
				bgColor: g?.bgColor || 'secondary',
			};
			for (const a of this.filtered(g.items || [], groupType)) {
				out.push({ ...a, badge, __groupType: groupType });
			}
		}

		const desc = (v) => ((v?.description ?? v?.name ?? '') + '').trim();
		this.allFilteredAddresses = out.sort((x, y) =>
			desc(x).localeCompare(desc(y), undefined, { sensitivity: 'base', numeric: true })
		);
	}

	filtered(items, groupType) {
		if (groupType) {
			if (this.typeFilter.length && !this.typeFilter.includes(groupType.toString())) return [];
		}

		const q = (this.search || '').trim().toLowerCase();
		if (!q) return items;

		return items.filter(a => {
			const parts = [
				a?.description, a?.name, a?.address_line_1, a?.address_line_2, a?.address_line_3,
				a?.posttown, a?.county, a?.postcode, a?.country
			]
				.filter(Boolean)
				.map((x: string) => x.toLowerCase());

			return parts.some(p => p.includes(q));
		});
	}

	formatGroupLabel(label) {
		const base = label.split('_').join(' ');
		return base.endsWith('s') ? base.slice(0, -1) : base;
	}

	isSelected(item: any) {
		if (!this.selected) return false;
		return this.app.compareAddress(item, this.selected);
	}

	toggle(type) {
		this.expanded[type] = !this.expanded[type];
	}

	expandAll() {
		for (const g of this.addressGroups) {
			this.expanded[g.type] = true;
		}
	}

	collapseAll() {
		for (const g of this.addressGroups) {
			this.expanded[g.type] = false;
		}
	}

	canCollapseAll() {
		return !!Object.keys(this.expanded).length;
	}

	selectAddress(a: any) {
		this.selected = a;
		this.modal.close(a);
	}

	onSearchChange(value) {
		this.search = value;
		this.computeAddressesForList();
	}

	onTypesChange(ids) {
		this.typeFilter = ids || [];
		for (const g of this.addressGroups) {
			const t = (g?.type ?? '').toString();
			this.expanded[t] = !this.typeFilter.length || this.typeFilter.includes(t);
		}
		this.computeAddressesForList();
	}

}
